
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

// > services/types <
import { WaybillCourier } from '@/modern/modules/m-dispatcher-module/services/types/waybill.types'

export default defineComponent({
    props: {
        courier: {
            type: [Object, null] as PropType<WaybillCourier | null>,
            default: null
        },
    }
})
